<!--
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-06-20 13:41:57
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-07-06 15:27:14
 * @FilePath: \xm-runing-main\src\components\xm-tenant-toggle\components\xm-tenant-toggle-dropdown.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang="ts">
import { DownOutlined } from '@ant-design/icons-vue';
import {
  Dropdown as ADropdown,
  Menu as AMenu,
  MenuItem as AMenuItem,
  SubMenu as ASubMenu,
} from 'ant-design-vue'

import { useXmTenantAndIndustryDropdownStore } from '../stores/xm-tenant-and-industry-dropdown'
import XmAgentAndIndustryModal from './xm-tenant-and-industry-modal.vue';

const XmTenantAndIndustryDropdownStore = useXmTenantAndIndustryDropdownStore()

const {
  currentTitle,
  dropdownProps,
  menuProps,
  tenantList,
  isMultiple
} = storeToRefs(XmTenantAndIndustryDropdownStore)

const {
  onSelect
} = XmTenantAndIndustryDropdownStore
</script>

<template>
  <ADropdown v-if="isMultiple" v-bind="dropdownProps">
    <a class="ant-dropdown-link" @click.prevent>
      {{ currentTitle }}
      <DownOutlined />
    </a>

    <template #overlay>
      <AMenu v-bind="menuProps" @select="onSelect">
        <template v-for="item of tenantList" :key="item.value">
          <AMenuItem v-if="!item.children?.length" :key="item.value" :title="item.title">
            <a href="javascript:;">{{ item.label }}</a>
          </AMenuItem>

          <ASubMenu v-else :title="item.label" :key="item.value">
            <AMenuItem v-for="_item of item.children!" :key="_item.value" :title="_item.title">
              <a href="javascript:;">{{ _item.label }}</a>
            </AMenuItem>
          </ASubMenu>
        </template>
      </AMenu>
    </template>
  </ADropdown>

  <XmAgentAndIndustryModal />
</template>

<style lang="less" scoped>
.ant-dropdown-link {
  font-size: var(--el-font-size-base);
  color: var(--el-text-color-primary, #0a001f);
}
</style>
